import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const getColumnSize = (opts) => {
  const {
    defaultSize,
    extraSmallSize,
    smallSize,
    mediumSize,
    largeSize,
    extraLargeSize
  } = opts;
  let columnSize = '';
  if (defaultSize) {
    columnSize += `col__${defaultSize}`;
  }
  if (extraSmallSize) {
    columnSize += ` col__${extraSmallSize}--xs`;
  }
  if (smallSize) {
    columnSize += ` col__${smallSize}--sm`;
  }
  if (mediumSize) {
    columnSize += ` col__${mediumSize}--md`;
  }
  if (largeSize) {
    columnSize += ` col__${largeSize}--lg`;
  }
  if (extraLargeSize) {
    columnSize += ` col__${extraLargeSize}--xl`;
  }
  return columnSize;
};

/**
 * @group Layout
 * Displays legacy column component for deprecated content grid
 */

const Column = (props) => {
  const { opts, children } = props;
  const { id, name } = opts;
  const columnSize = getColumnSize(opts);
  const gridClass = classNames(columnSize);

  return (
    <div
      className={gridClass}
      id={name || id}
    >
      <div className="content">
        {children}
      </div>
    </div>
  );
};

Column.propTypes = {
  children: PropTypes.instanceOf(Object),
  opts: PropTypes.shape({
    id: PropTypes.string,
    isColumnRail: PropTypes.bool,
    name: PropTypes.string
  }).isRequired,
};
Column.defaultProps = {
  children: []
};

export default Column;
